module.exports = __webpack_public_path__ + "static/media/JustinResumeApr2019.f604b0f9.pdf";